import { useMediaQuery, useTheme } from "@mui/material";

export function useResponsiveCols() {
  const theme = useTheme();
  const upSm = useMediaQuery(theme.breakpoints.up("sm"));
  const upMd = useMediaQuery(theme.breakpoints.up("md"));
  const upLg = useMediaQuery(theme.breakpoints.up("lg"));
  if (upLg) return 3;
  if (upMd) return 3;
  if (upSm) return 2;
  return 2;
}
